import { Event } from '@/types/residents/event';

export function buildICS(event: Event): string {
  const dtStart = toICSDate(event.startTimeLocal || event.startTime);
  const dtEnd = toICSDate(event.endTimeLocal || event.endTime || event.startTime);
  const uid = `resio-${event.id}@events`;
  const summary = escapeICS(event.name || 'Resio Event');
  const description = escapeICS(event.description || event.responseDescription || '');
  const location = escapeICS(event.location || event.address || '');

  return [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Resio//Resident Portal//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${toICSDate(new Date().toISOString())}`,
    `DTSTART:${dtStart}`,
    `DTEND:${dtEnd}`,
    `SUMMARY:${summary}`,
    description ? `DESCRIPTION:${description}` : '',
    location ? `LOCATION:${location}` : '',
    'END:VEVENT',
    'END:VCALENDAR',
  ].filter(Boolean).join('\r\n');
}

export function toICSDate(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return [
    d.getUTCFullYear(),
    pad(d.getUTCMonth() + 1),
    pad(d.getUTCDate()),
  ].join('') + 'T' + [pad(d.getUTCHours()), pad(d.getUTCMinutes()), pad(d.getUTCSeconds())].join('') + 'Z';
}

export function escapeICS(text: string): string {
  return text
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;');
}

export function buildGoogleCalendarUrl(event: Event): string {
  const base = 'https://calendar.google.com/calendar/render?action=TEMPLATE';
  const text = encodeURIComponent(event.name || 'Resio Event');
  const details = encodeURIComponent(event.description || event.responseDescription || '');
  const location = encodeURIComponent(event.location || event.address || '');
  const dates = toGoogleDates(event.startTimeLocal || event.startTime, event.endTimeLocal || event.endTime || event.startTime);
  return `${base}&text=${text}&details=${details}&location=${location}&dates=${dates}`;
}

export function toGoogleDates(start?: string, end?: string): string {
  const fmt = (iso?: string) => {
    if (!iso) return '';
    const d = new Date(iso);
    const pad = (n: number) => String(n).padStart(2, '0');
    return [
      d.getUTCFullYear(),
      pad(d.getUTCMonth() + 1),
      pad(d.getUTCDate()),
    ].join('') + 'T' + [pad(d.getUTCHours()), pad(d.getUTCMinutes()), pad(d.getUTCSeconds())].join('') + 'Z';
  };
  const s = fmt(start);
  const e = fmt(end);
  return `${s}/${e}`;
}


